var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionDeactivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 10.88L10.88 12 8 9.12 5.12 12 4 10.88 6.88 8 4 5.12 5.12 4 8 6.88 10.88 4 12 5.12 9.12 8 12 10.88z",
    fill: "#323232"
  })));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTVRZaUlHaGxhV2RvZEQwaU1UWWlJSFpwWlhkQ2IzZzlJakFnTUNBeE5pQXhOaUlnWm1sc2JEMGlibTl1WlNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWo0S1BIQmhkR2dnWkQwaVRUZ2dNRU16TGpZZ01DQXdJRE11TmlBd0lEaERNQ0F4TWk0MElETXVOaUF4TmlBNElERTJRekV5TGpRZ01UWWdNVFlnTVRJdU5DQXhOaUE0UXpFMklETXVOaUF4TWk0MElEQWdPQ0F3V2sweE1pQXhNQzQ0T0V3eE1DNDRPQ0F4TWt3NElEa3VNVEpNTlM0eE1pQXhNa3cwSURFd0xqZzRURFl1T0RnZ09FdzBJRFV1TVRKTU5TNHhNaUEwVERnZ05pNDRPRXd4TUM0NE9DQTBUREV5SURVdU1USk1PUzR4TWlBNFRERXlJREV3TGpnNFdpSWdabWxzYkQwaUl6TXlNekl6TWlJdlBnbzhMM04yWno0SyI=";
export { SvgActionDeactivate as ReactComponent };